module.exports = __webpack_public_path__ + "static/media/pos_slideshow1.33ca4c3a.jpg";